module.exports = __webpack_public_path__ + "assets/img/tjcs-main-back.cfc5425d.png";